import { Col, Input, Row, List } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import { useState, useEffect } from "react";
import { FollowCount } from "../../components/layout/FollowCount";
import { AvatarLayout } from "../../components/publications/AvatarLayout";
import "../templates/FollowersSider.css";

const toArray = (value) => (Array.isArray(value) ? value : []);
const getCounterClassName = (visibleList, listType) =>
  `follow-count-clickable${
    visibleList === listType ? " follow-count-clickable--active" : ""
  }`;

export const FollowersSider = ({

  following,
  followers,
  connections,
  uiTexts,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 992 });
  const [visibleList, setVisibleList] = useState("following");
  const [searchText, setSearchText] = useState("");
  const followingList = toArray(following);
  const followersList = toArray(followers);
  const connectionsList = toArray(connections);

  const handleFollowCountClick = (listType) => {
    setVisibleList(listType);
  };

  const filteredList = () => {
    const list =
      {
        following: followingList,
        followers: followersList,
        connections: connectionsList,
      }[visibleList] || [];

    return list.filter((item) => {
      const fullName = `${item?.nombres || ""} ${item?.apellidos || ""}`.toLowerCase();
      const search = searchText.toLowerCase();
      return (
        fullName.includes(search) ||
        item?.nickName?.toLowerCase().includes(search)
      );
    });
  };

  const getListTitle = () => {
    switch (visibleList) {
      case "following":
        return `${uiTexts?.LB0066 || "Siguiendo"} (${followingList.length})`;
      case "followers":
        return `${uiTexts?.LB0067 || "Seguidores"} (${followersList.length})`;
      case "connections":
        return `${uiTexts?.LB0068 || "Conexiones"} (${connectionsList.length})`;
      default:
        return "";
    }
  };

  useEffect(() => {}, []);

  return (
    <div className="followers-sider-container">
      {/* Sección de contadores */}
      {!isMobile ? (
        <Row justify={"space-evenly"}>
          <Col span={7}>
            <div
              onClick={() => handleFollowCountClick("following")}
              className={getCounterClassName(visibleList, "following")}
            >
              <FollowCount count={followingList.length} text={uiTexts?.LB0066 || "Siguiendo"} />
            </div>
          </Col>
          <Col span={7}>
            <div
              onClick={() => handleFollowCountClick("followers")}
              className={getCounterClassName(visibleList, "followers")}
            >
              <FollowCount count={followersList.length} text={uiTexts?.LB0067 || "Seguidores"} />
            </div>
          </Col>
          {/* Tarjeta de conexiones comentada temporalmente; reactivar si se vuelve a mostrar este contador.
          <Col span={7}>
            <div
              onClick={() => handleFollowCountClick("connections")}
              className="follow-count-clickable"
            >
              <FollowCount count={connectionsList.length} text={uiTexts?.LB0068 || "Conexiones"} />
            </div>
          </Col>
          */}
        </Row>
      ) : (
        <div className="followers-sider-mobile">
          <div className="followers-sider-flexbox">
            <div
              className={getCounterClassName(visibleList, "following")}
              onClick={() => handleFollowCountClick("following")}
            >
              <FollowCount count={followingList.length} text={uiTexts?.LB0066 || "Siguiendo"} />
            </div>
            <div
              className={getCounterClassName(visibleList, "followers")}
              onClick={() => handleFollowCountClick("followers")}
            >
              <FollowCount count={followersList.length} text={uiTexts?.LB0067 || "Seguidores"} />
            </div>
            {/* Tarjeta de conexiones comentada temporalmente; reactivar si se vuelve a mostrar este contador.
            <div
              className="follow-count-clickable"
              onClick={() => handleFollowCountClick("connections")}
            >
              <FollowCount count={connectionsList.length} text={uiTexts?.LB0068 || "Conexiones"} />
            </div>
            */}
          </div>
        </div>
      )}

      {/* Input de búsqueda */}
      <div className="input-profile-counter-contain">
        <Input
          placeholder={`${uiTexts?.LB0495 || "Buscar por nombre o nickname"}...`}
          size="middle"
          suffix={<SearchOutlined />}
          allowClear
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: "100%" }}
          disabled={!visibleList}
        />
      </div>

      {/* Lista de resultados */}
      {visibleList && (
        <div className="followers-sider-list-wrapper">
          <h4 className="followers-sider-title ">{getListTitle()}</h4>
          <List
            dataSource={filteredList()}
            renderItem={(item) => (
              <List.Item className="followers-sider-list-item">
                <AvatarLayout userData={item} />
              </List.Item>
            )}
            className="followers-sider-list"
            locale={{ emptyText: uiTexts?.LB0418 || "No se encontraron resultados" }}
          />
        </div>
      )}
    </div>
  );
};
